module.exports = __webpack_public_path__ + "img/calendar-gear.d4cb053c.svg";